export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";